/**
 * Application Configuration
 * 
 * This file contains centralized configuration for the frontend application.
 * All configuration values should be defined here to allow easy updates
 * without relying on environment variables in production.
 */

/**
 * Backend API URL
 * 
 * This is the base URL for all backend API calls.
 * In production, this should point to the deployed backend API.
 * 
 * Note: The .env file is not uploaded to production, so we hardcode
 * the production URL here with a fallback for local development.
 */
export const BACKEND_URL = "https://api.livechat.aqary.ai";

// export const BACKEND_URL = "http://localhost:8000";

/**
 * Get the backend URL for API calls
 * 
 * @returns The backend URL to use for all API calls
 */
export function getBackendUrl(): string {
  console.log(`🔗 [CONFIG] Using backend URL: ${BACKEND_URL}`);
  return BACKEND_URL;
}

